module.exports = {
  loginModule: {
    email: 'Email',
    password: 'Password',
    validCode: 'Verification Code',
    verificationCode: 'Verification Code',
    login: "Log In",
    forgotPassword: 'Forgot Password',
    register: 'Register',
    agreement: "I have read and agree to the",
    privacyPolicy: 'Privacy Policy',
    projectName: "Support Portal",
    passwordRetrieval: "Password Retrieval",
    forgotPassHint: "A verification code has been sent to your email to verify your identity.",
    noCode: 'No code received?',
    sendAgain: 'Send it again',
    newPassword: "New Password",
    confirmPassword: 'Confirm new password',
    confirmPassword2: "Confirm Password",
    next: "Next",
    confirm: "Confirm",
    sendCode: 'Send Verification Code',
    haveAccount: "Have an account?",
    checkCode: 'Verification code check',
    check: 'Check',
    companyName: 'Company Name',
    tel: "Tel",
    address: 'Address',
    countryRegion: 'Country/Region',
    city: 'City',
    state: 'State',
    industry: 'Industry',
    firstName: 'First Name',
    lastName: 'Last Name',
  }
}